import { doBootstrapOnboarding } from '../../actions'
import { doUpdateCompanyProfile } from '../../ducks/companyProfile/operations'
import { SHOPIFY_TRIAL_PAGE } from '../../pages'

export function doSaveAndRedirect(fields) {
  return dispatch => {
    const companyFields = {
      name: fields.companyName,
      numberOfEmployees: fields.numberOfEmployees,
      industry: fields.industry,
      currentSupportSolution: fields.currentSupportSolution,
    }

    return dispatch(doUpdateCompanyProfile(companyFields)).then(() => {
      // HACK (jscheel): Because updating the company profile can change the
      // subdomain, we need to get the new subdomain back. This really should
      // come from the backend response, but in the interest of time, just doing
      // an extra request here to get this out.
      return dispatch(doBootstrapOnboarding()).then(() => {
        return dispatch({
          type: SHOPIFY_TRIAL_PAGE,
        })
      })
    })
  }
}
